import React from 'react';
import quickReportsPic from 'src/static/images/tutorials/tutorial-quick-reports.webp';
import engagementHubPic from 'src/static/images/tutorials/tutorial-engagements-hub.webp';
import { TutorialType } from './TutorialsContext';
import { useTutorialsIntl } from './translations/useTutorialsIntl';

type AllTutorials = { [key in TutorialType]: TutorialParts };

type TutorialParts = {
  heading: string;
  sections: { key: string; message: string | JSX.Element }[];
  img: string;
};

export const useTutorialsTemplate = (): AllTutorials => {
  const intl = useTutorialsIntl();

  return {
    ENGAGEMENTS_HUB: {
      heading: intl.newEngagementHubTitle,
      sections: [
        { key: '1', message: intl.newEngagementHubDescription1 },
        {
          key: '2',
          message: (
            <ul>
              <li>{intl.newEngagementHubDescription2}</li>
              <li>{intl.newEngagementHubDescription3}</li>
              <li>{intl.newEngagementHubDescription4}</li>
            </ul>
          )
        }
      ],
      img: engagementHubPic
    },
    QUICK_REPORTS: {
      heading: intl.tutorial2Header,
      sections: [
        { key: '1', message: intl.tutorial2Pt1 },
        {
          key: '2',
          message: (
            <ul>
              <li>{intl.tutorial2Pt2}</li>
              <li>{intl.tutorial2Pt3}</li>
            </ul>
          )
        }
      ],
      img: quickReportsPic
    }
  };
};
